import { useState } from "react";
import { BellRing } from "lucide-react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { setReminders, errorDetail } from "@/lib/reader";

export default function RemindersToggle({ enabled }) {
  const [on, setOn] = useState(enabled);
  const toggle = async (value) => {
    setOn(value);
    try {
      await setReminders(value);
      toast.success(value ? "Evening reminders are on." : "Evening reminders are off.");
    } catch (err) {
      setOn(!value);
      toast.error(errorDetail(err));
    }
  };
  return (
    <div className="mt-4 border border-white/10 bg-[#121212] p-6 flex items-center justify-between gap-6" data-testid="account-reminders">
      <div className="flex items-start gap-3">
        <BellRing className="w-5 h-5 text-primary-gold shrink-0 mt-0.5" />
        <div>
          <p className="font-mono-ui text-[10px] uppercase tracking-[0.22em] text-primary-gold">Evening reading reminder</p>
          <p className="text-soft text-sm mt-1">A friendly email at 7pm your time on days you haven't read yet, while your pass is active.</p>
        </div>
      </div>
      <Switch checked={on} onCheckedChange={toggle} data-testid="account-reminders-switch" className="border border-white/30 data-[state=unchecked]:bg-white/15" />
    </div>
  );
}
